module["exports"] = [
  "0912 ### ####",
  "0911 ### ####",
  "0919 ### ####",
  "0917 ### ####",
  "0920 ### ####",
  "0921 ### ####",
  "0936 ### ####",
  "0937 ### ####",
  "0938 ### ####",
  "0939 ### ####",
  "0935 ### ####",
  "0933 ### ####",
  "0901 ### ####",
  "0902 ### ####",
  "0903 ### ####",
  "0904 ### ####",
  "0905 ### ####"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/fa/cell_phone/formats.js
// module id = 2909
// module chunks = 1609